<template>
  <div class="transaction_h">
    <div class="t_h1">
      <div class="bal_list">
        <div
          class="b_item1"
          :class="account_type == 3 ? 'acc_btn_act' : ''"
          @click="account_type = 3"
        >
          <div>
            <div class="b_txt1">{{ $t("main.text40") }}</div>
            <div class="b_txt2">$ {{ set_num3_2(usdt_balance) }}</div>
          </div>
          <div>
            <img
              v-if="account_type == 3"
              class="b_img"
              src="../../assets/img/home_icon1.png"
              alt=""
            />
            <img
              v-else
              style="opacity: 0.2"
              class="b_img"
              src="../../assets/img/home_icon1.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="b_item1"
          :class="account_type == 4 ? 'acc_btn_act' : ''"
          @click="account_type = 4"
        >
          <div>
            <div class="b_txt1">{{ $t("main.text41") }}</div>
            <div class="b_txt2">$ {{ set_num3_2(usdc_balance) }}</div>
          </div>
          <div>
            <img
              v-if="account_type == 4"
              class="b_img"
              src="../../assets/img/home_icon2_act.png"
              alt=""
            />
            <img
              v-else
              style="opacity: 0.2"
              class="b_img"
              src="../../assets/img/home_icon2_act.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="t_h1_top">{{ $t("main.text322") }}</div>
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top" :model="form">
          <el-form-item :label="$t('main.text323')" class="riqi_box">
            <el-date-picker
              :editable="false"
              popper-class="time_box"
              :clearable="false"
              v-model="form.t_h_time"
              type="daterange"
              :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('main.text324')"
              :end-placeholder="$t('main.text325')"
              :picker-options="pickerOptions2"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('main.text326')">
            <el-input v-model="form.t_h_id" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('main.text334')">
            <el-select
              v-model="form.t_h_type"
              :placeholder="$t('main.text328')"
            >
              <!-- BTC ETH USDT-ERC20 USDT-TRC20 USDT-BSC20 USDC-ERC20 USDC-TRC20 USDC-BSC20 USD SGD CNY GBP AUD HKD -->
              <!-- <el-option label="BTC" value="BTC"></el-option>
              <el-option label="ETH" value="ETH"></el-option> -->
              <el-option
                label="USDT-ERC20"
                value="USDT-ERC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDT-TRC20"
                value="USDT-TRC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDT-BEP20"
                value="USDT-BSC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDC-ERC20"
                value="USDC-ERC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USDC-TRC20"
                value="USDC-TRC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USDC-BEP20"
                value="USDC-BSC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USD"
                value="USD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="SGD"
                value="SGD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="CNY"
                value="CNY"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="GBP"
                value="GBP"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="AUD"
                value="AUD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="HKD"
                value="HKD"
                v-if="account_type == 4"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('main.text327')">
            <el-select
              v-model="form.trade_type"
              :placeholder="$t('main.text328')"
            >
              <el-option :label="$t('main.text328')" :value="0"></el-option>
              <el-option :label="$t('new1_txt.CR')" :value="1"></el-option>
              <el-option :label="$t('new1_txt.DR')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="t_h2">
      <div class="t_h2_box">
        <div>
          <div class="t_h2_txt1">{{ $t("main.text270") }}</div>
          <div class="t_h2_txt2">
            <div style="color: #12ba9c">{{ $t("main.text775") }}</div>
            <div>{{ $t("main.text776") }}</div>
          </div>
        </div>
        <div>
          <el-button
            class="export_btn border_set_color2"
            icon="el-icon-download"
            size="medium"
            @click="download_btn"
            >{{ $t("main.text333") }}</el-button
          >
        </div>
      </div>
      <div class="t_h2_table zdy_tab_header">
        <el-table
          :data="tableData"
          stripe
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column :label="$t('main.text99')" min-width="120">
            <span slot-scope="props">
              {{ overall_time(props.row.c_time) }}
            </span>
          </el-table-column>

          <el-table-column :label="$t('main.text751')" min-width="260">
            <span slot-scope="props">
              <span v-html="props.row.type_name"></span>
            </span>
          </el-table-column>

          <el-table-column prop="tx_id" :label="$t('main.text326')" min-width="120">
          </el-table-column>

          <el-table-column :label="$t('main.text769')" min-width="120">
            <span slot-scope="props">
              <span v-if="props.row.action == 11">
                {{ set_num3_2(props.row.amount) }}
              </span>
              <span v-else>-</span>
            </span>
          </el-table-column>
          <el-table-column :label="$t('main.text770')" min-width="120">
            <span slot-scope="props">
              <span v-if="props.row.action == 10">
                {{ set_num3_2(props.row.amount) }}
              </span>
              <span v-else>-</span>
            </span>
          </el-table-column>

          <!-- <el-table-column prop="balance" :label="$t('main.text771')">
          </el-table-column> -->
          <el-table-column :label="$t('main.text771')" min-width="120">
            <span slot-scope="props">
              {{ set_num3_2(props.row.balance) }}
            </span>
          </el-table-column>

          <el-table-column width="80">
            <span slot-scope="props">
              <img
                @click="to_info(props.row.tx_id, props.row.id)"
                class="icon_width"
                src="../../assets/img/look_icon.png"
                alt=""
              />
            </span>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="tableData.length > 0"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="page_total"
          @current-change="current_change"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  transaction_record,
  transaction_download,
  transaction_details,
} from "@/api/api";
// 使用时间转换插件 moment.js
import moment from 'moment'
export default {
  data() {
    return {
      pickerOptions2: {
        disabledDate: (time) => {
          // 往前6个月 1号开始
          const d = Date.now() - 180 * 24 * 60 * 60 * 1000;
          const month = moment(d).format("YYYY-MM");
          const min_month = (new Date(`${month}-01 00:00:00`)).getTime();

          return (
            time.getTime() > Date.now() ||
            time.getTime() < min_month
          );
        },
      },
      form: {
        t_h_time: "",
        t_h_id: "",
        t_h_type: "",
        trade_type: 0,
      },
      currentPage: 1, //选中的页数
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      account_type: 3, //	Number	1BTC 2ETH 3USDT 4USDC

      usdt_balance: 0,
      usdc_balance: 0,
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  watch: {
    account_type() {
      this.get_list();
    },
  },
  mounted() {
    
    this.get_list();
  },
  methods: {
    reset_btn() {
      this.form.t_h_time = "";
      this.form.t_h_id = "";
      this.form.t_h_type = "";
      this.form.trade_type = 0;
      this.form.balance_type = "USDC";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    get_list() {
      transaction_record({
        page: this.page,
        limit: this.limit,
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        tx_id: this.form.t_h_id,
        status: "",
        action: this.form.trade_type,
        account_type: this.account_type,
        token_type: this.form.t_h_type,
      }).then((res) => {
        if (res.data.code == 200) {
          
          this.page_total = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });

      transaction_details().then((res) => {
        if (res.data.code == 200) {
          
          this.usdt_balance = res.data.data.usdt_balance;
          this.usdc_balance = res.data.data.usdc_balance;
        }
      });
    },
    cellStyle({ row }) {
      // tx_type: 1加密货币 2法币 法币 那行为绿色文字
      if (row.tx_type == 2) {
        return "color:#12BA9C";
      } else {
        return "";
      }
    },
    current_change(v) {
      
      this.page = v;
      this.limit = 10;
      this.get_list();
    },
    to_info(tx_id, id) {
      sessionStorage.setItem("my_info_tx_id", tx_id);
      sessionStorage.setItem("my_info_id", id);
      setTimeout(() => {
        this.$router.push("/my_transaction_info");
      }, 100);
    },
    download_btn() {
      if (this.page_total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      transaction_download({
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        tx_id: this.form.t_h_id,
        status: "",
        action: this.form.trade_type,
        account_type: this.account_type,
        token_type: this.form.t_h_type,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style scoped>
.t_h1_top {
  /* margin-top: 40px; */
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #232a36;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner {
  background: #333a47;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  min-width: 140px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #bbbbbb;
  background: transparent;
  border: 1.25px solid #bbbbbb;
  border-radius: 4px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 140px;
  border-color: #00c18e;
  background: #00c18e;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #191e29;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  min-width: 136px;
  color: #00c18e;
  border-color: #00c18e;
  border-style: solid;
  border-width: 1.5px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}

.acc_list {
  margin-bottom: 10px;
}
.acc_btn {
  background-color: transparent;
  border: 1.5px solid #f1c788;
  color: #deb981;
  min-width: 70px;
}
.acc_btn_act {
  /* background: #deb981 !important; */
  background: #00C18E !important;
}
/* ---- */
.bal_list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  color: #fff;
}
.b_item1 {
  width: 100%;
  max-width: 400px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  background: #04182a;
  border-radius: 16px;
  margin-right: 20px;
  cursor: pointer;
}
.b_txt1 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  opacity: 0.8;
  padding-bottom: 12px;
}
.b_txt2 {
  font-size: 28px;
}
.b_img {
  max-width: 68px;
}

/* ---- */
</style>

